// extracted by mini-css-extract-plugin
export default {"language-select":"BiographyLanguageSelect_language-select__GJ4TM"};